module.exports = __webpack_public_path__ + "sx7-8781dba3.png";